<script setup>
import { defineAsyncComponent } from 'vue'
import AppBadge from '@/components/atoms/AppBadge'

// lightgallery loads with the first video, so it stays out of the layout's bundle.
const HelpHubStepVideoLightbox = defineAsyncComponent(() => import('./HelpHubStepVideoLightbox.vue'))

defineProps({
  image: { type: String, required: true },
  video: { type: String, default: '' },
  // The help page the video sits on, for the play event.
  slug: { type: String, default: '' },
})
</script>

<template>
  <div class="relative overflow-hidden rounded-2xl shadow-md">
    <!-- Figma keeps the height as the hub widens and crops the picture instead. -->
    <img :src="image" alt="" loading="lazy" class="block h-44 w-full object-cover" />

    <!-- Keyed: lightgallery reads the video once, when it mounts. -->
    <HelpHubStepVideoLightbox v-if="video" :key="video" :video="video" :slug="slug" />

    <AppBadge
      size="xs"
      custom-class="bg-black/60 text-white"
      class="pointer-events-none absolute bottom-2 left-2"
    >
      Watch
    </AppBadge>
  </div>
</template>
